import { render, staticRenderFns } from "./DashboardWidgetCassaDisavanzo.vue?vue&type=template&id=666ac045&"
import script from "./DashboardWidgetCassaDisavanzo.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetCassaDisavanzo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports